import Konva from 'konva';
import * as buttons from 'smg/buttons';
import { AddCartItemParamsUpload, AddCartItems } from 'smg/customer-api/v2/carts';
import { ShowError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import Modal from 'smg/modal';
import * as template from 'smg/template';
import * as uploads from 'smg/uploads';
import * as models from 'smg/customer-api/models';
import { Relref } from '../hugo';
import * as stockitems from '../stockitems';

void main();

async function main() {
    stockitems.InitGallery();
    stockitems.InitSeeMore();

    const $modalCanvasParent = template.Clone('#modal-canvas-parent-template').firstElementChild as HTMLElement;
    $modalCanvasParent.style.position = 'absolute';
    $modalCanvasParent.style.top = '-10000px';
    $modalCanvasParent.style.left = '-10000px';
    document.body.appendChild($modalCanvasParent);

    const $dropContainersParent = document.querySelector('#drop-containers-parent') as HTMLDivElement;

    $dropContainersParent.append(template.Clone('#drop-container-front-one-template'));
    $dropContainersParent.append(template.Clone('#drop-container-front-two-template'));
    $dropContainersParent.append(template.Clone('#drop-container-back-one-template'));
    $dropContainersParent.append(template.Clone('#drop-container-back-two-template'));

    const $form = document.querySelector('#stock-item-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $frontTopText = document.querySelector('#front-top-text') as HTMLTextAreaElement;
    const $frontBottomText = document.querySelector('#front-bottom-text') as HTMLTextAreaElement;
    const $backTopText = document.querySelector('#back-top-text') as HTMLTextAreaElement;
    const $backBottomText = document.querySelector('#back-bottom-text') as HTMLTextAreaElement;

    const $quantity = document.querySelector('#quantity') as HTMLInputElement;
    const $addToCart = document.querySelector('#add-to-cart') as HTMLButtonElement;
    const $personalize = document.querySelector('#personalize') as HTMLButtonElement;
    const $reopenEditor = document.querySelector('#reopen-editor-button-parent') as HTMLDivElement;

    const $modalDivider = document.querySelector('#modal-divider') as HTMLDivElement;

    const $canvasContainer = document.querySelector('#canvas-container') as HTMLDivElement;
    const $modalMainRow = document.querySelector('#modal-main-row') as HTMLDivElement;

    const $preview = document.querySelector('#preview-image-parent') as HTMLDivElement;

    const $fields = document.querySelector('#modal-right') as HTMLElement;
    const $frontInputs = document.querySelector('#front-inputs') as HTMLDivElement;
    const $backInputs = document.querySelector('#back-inputs') as HTMLDivElement;

    const $navAlert = document.querySelector('#alert-nav-no-img') as HTMLDivElement;

    const $metaThemeColor = document.querySelector("meta[name='theme-color']") as HTMLMetaElement;
    const initialThemeColor = $metaThemeColor.content;

    const frontOnePlaceholderImg = `${Relref('/')}img/custom-hc-bottle-openers/placeholder-front-one.png`; // TODO: bundle these or something to avoid using Relref('/')
    const backOnePlaceholderImg = `${Relref('/')}img/custom-hc-bottle-openers/placeholder-back-one.png`;
    const defaultPlaceholderImg = `${Relref('/')}img/no-minimum-custom-coins/placeholder-image.png`;

    let modalActive = false;
    let backFace = false;
    let frontOneUploaded = false;
    let frontTwoUploaded = false;
    let backOneUploaded = false;
    let backTwoUploaded = false;

    let editedTextFT = false;
    let editedTextFB = false;
    let editedTextBT = false;
    let editedTextBB = false;

    let firstOpen = true;

    const $canvasParent = document.querySelector('#canvas-parent') as HTMLDivElement;

    const $canvasUploaderLabelFrontOne = document.querySelector('#canvas-uploader-front-one') as HTMLLabelElement;
    const $canvasUploaderLabelFrontTwo = document.querySelector('#canvas-uploader-front-two') as HTMLLabelElement;
    const $canvasUploaderLabelBackOne = document.querySelector('#canvas-uploader-back-one') as HTMLLabelElement;
    const $canvasUploaderLabelBackTwo = document.querySelector('#canvas-uploader-back-two') as HTMLLabelElement;

    document.querySelector('#close-alert-nav')?.addEventListener('click', () => $navAlert.classList.add('d-none'));
    $quantity.parentElement?.classList.add('d-none');
    $addToCart.classList.add('d-none');

    /**
     * Holds all the data needed to recreate a state of the modal editor.
    */
    interface editorState {
        /** Front top text */
        textFT: string;
        /** Front bottom text */
        textFB: string;
        /** Back top text */
        textBT: string;
        /** Back bottom text */
        textBB: string;

        editedTextFT: boolean;
        editedTextFB: boolean;
        editedTextBT: boolean;
        editedTextBB: boolean;

        frontOneUploaded: boolean;
        frontTwoUploaded: boolean;
        backOneUploaded: boolean;
        backTwoUploaded: boolean;

        imageFrontOne: {
            /** Image src blob URL */
            imageSrc: string;
            posX: number;
            posY: number;
            width: number;
            height: number;
            scaleX: number;
            scaleY: number;
            uploadID: number;
        };

        imageFrontTwo: {
            /** Image src blob URL */
            imageSrc: string;
            posX: number;
            posY: number;
            width: number;
            height: number;
            scaleX: number;
            scaleY: number;
            uploadID: number;
        };

        imageBackOne: {
            /** Image src blob URL */
            imageSrc: string;
            posX: number;
            posY: number;
            width: number;
            height: number;
            scaleX: number;
            scaleY: number;
            uploadID: number;
        };

        imageBackTwo: {
            /** Image src blob URL */
            imageSrc: string;
            posX: number;
            posY: number;
            width: number;
            height: number;
            scaleX: number;
            scaleY: number;
            uploadID: number;
        };
    }

    const stage = new Konva.Stage({
        container: $canvasParent,
    });

    const bgImage = await new Promise<Konva.Image>(resolve => {
        const img = new Image();
        img.onload = () =>
            resolve(new Konva.Image({
                image: img,
                draggable: false,
                listening: false,
            }));
        img.src = `${Relref('/')}img/custom-hc-bottle-openers/hc-background.png`;
    });

    const bgLayer = new Konva.Layer();
    bgLayer.id('bgLayer');
    stage.add(bgLayer);
    bgLayer.add(bgImage);

    let scale = 1;
    let offsetX = 0;
    let offsetY = 0;

    function fitStageIntoParentContainer(firstRun = true) {
        const $stageChildren: ChildNode[] = [];
        if (!firstRun) {
            $stageChildren.push(...Array.from($canvasContainer.childNodes));
            $canvasContainer.innerHTML = '';
        }

        if (modalActive) {
            stage.width($canvasContainer.offsetWidth * (3000 / 1500));
            stage.height(stage.width() * (1500 / 3000));
            scale = (($canvasContainer.offsetWidth * (3000 / 1500))) / bgImage.width();
        } else {
            stage.width(3000);
            stage.height(1500);
            scale = 1;
        }

        stage.scale({ x: scale, y: scale });

        if ($stageChildren) {
            for (const c of $stageChildren) {
                $canvasContainer.appendChild(c);
            }
        }

        offsetX = 0;
        offsetY = 0;

        if (modalActive) {
            if (backFace) {
                offsetX = 1500;
            }
            stage.offsetX(offsetX);
            stage.offsetY(-offsetY);
        } else {
            stage.offsetX(offsetX + -24);
            stage.offsetY(-offsetY);
        }

        $canvasContainer.setAttribute('style', `--scale:${scale};--offsetY:${offsetY}px;--offsetX:${offsetX}px`);
    }

    const $frontTopTextTemplate = document.querySelector('#hc-text-svg-front-top-template') as HTMLTemplateElement;
    const $frontBottomTextTemplate = document.querySelector('#hc-text-svg-front-bottom-template') as HTMLTemplateElement;
    const $backTopTextTemplate = document.querySelector('#hc-text-svg-back-top-template') as HTMLTemplateElement;
    const $backBottomTextTemplate = document.querySelector('#hc-text-svg-back-bottom-template') as HTMLTemplateElement;

    const $frontTopTextSVG = template.Clone($frontTopTextTemplate).firstElementChild?.querySelector('svg') as SVGElement;
    const $frontTopTextSVGText = $frontTopTextSVG.querySelector('#textPath1') as SVGTextPathElement;
    $frontTopTextSVGText.textContent = 'FRONT TOP TEXT';

    const getTextFrontTopSVGImage = () => {
        const img = new Image();
        const promise = new Promise<void>(resolve => img.addEventListener('load', () => resolve()));
        img.src = URL.createObjectURL(new Blob([$frontTopTextSVG.outerHTML], { type: 'image/svg+xml' }));
        return { img, promise };
    };
    const { img: frontTopImg, promise: frontTopPromise } = getTextFrontTopSVGImage();
    const textFrontTopImage = new Konva.Image({
        image: frontTopImg,
        width: 1500,
        height: 1500,
        x: 0,
        y: 0,
        id: 'textFrontTopImage',
    });
    const textFrontTopLayer = new Konva.Layer();
    textFrontTopLayer.id('textFrontTopLayer');
    textFrontTopLayer.add(textFrontTopImage);
    stage.add(textFrontTopLayer);

    async function updateFrontTopText(inputText: string) {
        $frontTopTextSVGText.textContent = inputText;
        const textFunc = getTextFrontTopSVGImage();
        await textFunc.promise;
        textFrontTopImage.image(textFunc.img);
    }

    $frontTopText.addEventListener('input', () => {
        editedTextFT = true;
        void updateFrontTopText($frontTopText.value);
    });

    const $frontBottomTextSVG = template.Clone($frontBottomTextTemplate).firstElementChild?.querySelector('svg') as SVGElement;
    const $frontBottomTextSVGText = $frontBottomTextSVG.querySelector('#textPath168884') as SVGTextPathElement;
    $frontBottomTextSVGText.textContent = 'FRONT BOTTOM TEXT';

    const getTextFrontBottomSVGImage = () => {
        const img = new Image();
        const promise = new Promise<void>(resolve => img.addEventListener('load', () => resolve()));
        img.src = URL.createObjectURL(new Blob([$frontBottomTextSVG.outerHTML], { type: 'image/svg+xml' }));
        return { img, promise };
    };
    const { img: frontBottomImg, promise: frontBottomPromise } = getTextFrontBottomSVGImage();
    const textFrontBottomImage = new Konva.Image({
        image: frontBottomImg,
        width: 1500,
        height: 1500,
        x: 0,
        y: 0,
        id: 'textFrontBottomImage',
    });
    const textFrontBottomLayer = new Konva.Layer();
    textFrontBottomLayer.id('textFrontBottomLayer');
    textFrontBottomLayer.add(textFrontBottomImage);
    stage.add(textFrontBottomLayer);

    async function updateFrontBottomText(inputText: string) {
        $frontBottomTextSVGText.textContent = inputText;
        const textFunc = getTextFrontBottomSVGImage();
        await textFunc.promise;
        textFrontBottomImage.image(textFunc.img);
    }

    $frontBottomText.addEventListener('input', () => {
        editedTextFB = true;
        void updateFrontBottomText($frontBottomText.value);
    });

    const $backTopTextSVG = template.Clone($backTopTextTemplate).firstElementChild?.querySelector('svg') as SVGElement;
    const $backTopTextSVGText = $backTopTextSVG.querySelector('#textPath1') as SVGTextPathElement;
    $backTopTextSVGText.textContent = 'BACK TOP TEXT';

    const getTextBackTopSVGImage = () => {
        const img = new Image();
        const promise = new Promise<void>(resolve => img.addEventListener('load', () => resolve()));
        img.src = URL.createObjectURL(new Blob([$backTopTextSVG.outerHTML], { type: 'image/svg+xml' }));
        return { img, promise };
    };

    const { img: backTopImg, promise: backTopPromise } = getTextBackTopSVGImage();
    const textBackTopImage = new Konva.Image({
        image: backTopImg,
        width: 1500,
        height: 1500,
        x: 1500,
        y: 0,
        id: 'textBackTopImage',
    });
    const textBackTopLayer = new Konva.Layer();
    textBackTopLayer.id('textBackTopLayer');
    textBackTopLayer.add(textBackTopImage);
    stage.add(textBackTopLayer);

    async function updateBackTopText(inputText: string) {
        $backTopTextSVGText.textContent = inputText;
        const textFunc = getTextBackTopSVGImage();
        await textFunc.promise;
        textBackTopImage.image(textFunc.img);
    }

    $backTopText.addEventListener('input', () => {
        editedTextBT = true;
        void updateBackTopText($backTopText.value);
    });

    const $backBottomTextSVG = template.Clone($backBottomTextTemplate).firstElementChild?.querySelector('svg') as SVGElement;
    const $backBottomTextSVGText = $backBottomTextSVG.querySelector('#textPath2') as SVGTextPathElement;
    $backBottomTextSVGText.textContent = 'BACK BOTTOM TEXT';

    const getTextBackBottomSVGImage = () => {
        const img = new Image();
        const promise = new Promise<void>(resolve => img.addEventListener('load', () => resolve()));
        img.src = URL.createObjectURL(new Blob([$backBottomTextSVG.outerHTML], { type: 'image/svg+xml' }));
        return { img, promise };
    };

    const { img: backBottomImg, promise: backBottomPromise } = getTextBackBottomSVGImage();
    const textBackBottomImage = new Konva.Image({
        image: backBottomImg,
        width: 1500,
        height: 1500,
        x: 1500,
        y: 0,
        id: 'textBackBottomImage',
    });
    const textBackBottomLayer = new Konva.Layer();
    textBackBottomLayer.id('textBackBottomLayer');
    textBackBottomLayer.add(textBackBottomImage);
    stage.add(textBackBottomLayer);

    async function updateBackBottomText(inputText: string) {
        $backBottomTextSVGText.textContent = inputText;
        const textFunc = getTextBackBottomSVGImage();
        await textFunc.promise;
        textBackBottomImage.image(textFunc.img);
    }

    $backBottomText.addEventListener('input', () => {
        editedTextBB = true;
        void updateBackBottomText($backBottomText.value);
    });

    const $stageLoader = document.querySelector('#stage-loader') as HTMLElement;

    const showLoading = () => {
        $canvasContainer.style.opacity = '0.5';
        $canvasContainer.style.pointerEvents = 'none';
        $stageLoader.classList.remove('d-none');
    };

    const hideLoading = () => {
        $canvasContainer.style.opacity = '';
        $canvasContainer.style.pointerEvents = '';
        $stageLoader.classList.add('d-none');
    };

    let frontOneZ = 0;
    let frontTwoZ = 0;
    let backOneZ = 0;
    let backTwoZ = 0;

    // start front one uploader

    let frontOneUploadID = 0;
    const frontOneUploadLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        width: bgImage.width(),
        height: bgImage.height(),
        id: 'frontOneUploadLayer',
    });
    const frontOneUploadImage = new Konva.Image({
        image: new Image(),
        id: 'frontOneUploadImage',
    });
    stage.add(frontOneUploadLayer);

    frontOneUploadLayer.add(frontOneUploadImage);

    const frontOneUploadTransformerLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        visible: false,
        id: 'frontOneUploadTransformerLayer',
    });
    const frontOneUploaderTransformer = new Konva.Transformer({
        anchorStroke: '#fff',
        borderStroke: '#1a73e8',
        anchorSize: 9,
        anchorFill: '#1a73e8',
        centeredScaling: true,
    });
    frontOneUploadTransformerLayer.add(frontOneUploaderTransformer);
    stage.add(frontOneUploadTransformerLayer);

    const frontOneTransformerShape = new Konva.Rect({
        draggable: true,
    });
    frontOneUploadTransformerLayer.add(frontOneTransformerShape);
    frontOneUploaderTransformer.nodes([frontOneTransformerShape]);

    const $dropContainerFrontOne = document.querySelector('#drop-container-front-one') as HTMLElement;
    const $stageUploadButtonFrontOne = document.querySelector('#stage-upload-button-front-one') as HTMLButtonElement;
    $stageUploadButtonFrontOne.addEventListener('click', () => $canvasUploaderLabelFrontOne.click());

    const $resetFrontOne = document.querySelector('#reset-front-one') as HTMLButtonElement;
    const $editFrontOne = document.querySelector('#edit-front-one') as HTMLButtonElement;
    const $changeImageFrontOne = document.querySelector('#change-image-front-one') as HTMLButtonElement;
    const $doneFrontOne = document.querySelector('#done-front-one') as HTMLButtonElement;

    const startTransformModeFrontOne = () => {
        const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;
        const $editorButtonsFrontOne = document.querySelector('#editor-buttons-front-one') as HTMLDivElement;
        const $editorButtonsFrontTwo = document.querySelector('#editor-buttons-front-two') as HTMLDivElement;

        $editorButtons.classList.remove('d-none');
        $editorButtonsFrontOne.classList.remove('d-none');
        $editorButtonsFrontTwo.classList.add('d-none');
        document.querySelectorAll('.front-one-edit-controls').forEach($el => $el.classList.remove('d-none'));
        $editFrontOne.classList.add('d-none');

        $dropContainersParent.classList.add('pe-none');

        frontOneZ = frontOneUploadTransformerLayer.getZIndex();
        frontOneUploadTransformerLayer.setZIndex(50);
        frontOneUploadTransformerLayer.show();
    };

    const stopTransformModeFrontOne = () => {
        const $editorButtonsFrontTwo = document.querySelector('#editor-buttons-front-two') as HTMLDivElement;

        $editorButtonsFrontTwo.classList.remove('d-none');
        document.querySelectorAll('.front-one-edit-controls').forEach($el => $el.classList.add('d-none'));

        $dropContainersParent.classList.remove('pe-none');

        if (!backFace && frontOneUploaded) {
            $editFrontOne.classList.remove('d-none');
        }

        frontOneUploadTransformerLayer.setZIndex(frontOneZ);
        frontOneUploadTransformerLayer.hide();
    };

    let setFrontOneImageSizeAndPosition: () => void;

    $resetFrontOne.addEventListener('click', e => {
        e.preventDefault();
        setFrontOneImageSizeAndPosition?.();
    });

    $editFrontOne.addEventListener('click', startTransformModeFrontOne);
    $changeImageFrontOne.addEventListener('click', () => $canvasUploaderLabelFrontOne.click());
    $doneFrontOne.addEventListener('click', stopTransformModeFrontOne);

    let frontOneImg = new Image();
    let frontOneShape: Konva.Shape;

    const addImageFrontOne = (blobURL: string) => {
        const maskActualWidth = 660;
        const maskActualHeight = 715;
        const maskOffsetX = 430;
        const maskOffsetY = 340;
        frontOneImg = new Image();

        const mask = new Image();
        const promise = new Promise<void>(resolve => {
            if (blobURL === '') {
                if (frontOneShape) {
                    frontOneShape.destroy();
                }
                $dropContainerFrontOne.classList.remove('d-none');
                $stageUploadButtonFrontOne.classList.remove('d-none');
                resolve();
                return;
            }
            mask.onload = () => {
                frontOneImg.src = blobURL;
                frontOneImg.setAttribute('style', 'image-orientation:none');
                frontOneImg.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / frontOneImg.naturalWidth,
                        height: maskActualHeight / frontOneImg.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = frontOneImg.naturalWidth * coverRatio;
                    const newImageHeight = frontOneImg.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    frontOneTransformerShape.setAttrs({
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                        scaleX: 1,
                        scaleY: 1,
                    });
                    frontOneTransformerShape.draw();

                    if (frontOneShape) {
                        frontOneShape.destroy();
                    }

                    frontOneShape = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -frontOneShape.x(), -frontOneShape.y(), mask.naturalWidth, mask.naturalHeight);
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = frontOneUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(frontOneImg, 0, 0, frontOneUploaderTransformer.width() / stage.scaleX(), frontOneUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, frontOneUploaderTransformer.width() / stage.scaleX(), frontOneUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(frontOneShape);
                        },
                    });
                    setFrontOneImageSizeAndPosition = () => {
                        frontOneTransformerShape.rotation(0);
                        frontOneShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        frontOneTransformerShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        frontOneTransformerShape.draw();
                    };
                    setFrontOneImageSizeAndPosition();
                    frontOneUploadLayer.add(frontOneShape);

                    frontOneTransformerShape.off('dragmove');
                    frontOneTransformerShape.on('dragmove', () => frontOneShape.position(frontOneTransformerShape.position()));

                    frontOneTransformerShape.off('transform');
                    frontOneTransformerShape.on('transform', () => frontOneShape.position(frontOneTransformerShape.position()));

                    frontOneShape.on('click', () => startTransformModeFrontOne);

                    hideLoading();
                    resolve();
                };

                $dropContainerFrontOne.classList.add('d-none');
                $stageUploadButtonFrontOne.classList.add('d-none');
                startTransformModeFrontOne();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
        });
        mask.src = `${Relref('/')}img/custom-hc-bottle-openers/hc-mask-left-main.png`;
        $canvasContainer.classList.remove('no-edit-btn');
        return promise;
    };

    new uploads.Uploader($canvasUploaderLabelFrontOne, {
        dropZones: [$dropContainerFrontOne],
        start: showLoading,
        stop: hideLoading,
        success: async (thumb, uploadID, blobURL) => {
            $navAlert.classList.add('d-none');
            frontOneUploadID = uploadID;
            frontOneUploaded = true;
            await addImageFrontOne(blobURL);
        },
    });

    // stop front one uploader

    // start front two uploader

    let frontTwoUploadID = 0;
    const frontTwoUploadLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        width: bgImage.width(),
        height: bgImage.height(),
        id: 'frontTwoUploadLayer',
    });
    const frontTwoUploadImage = new Konva.Image({
        image: new Image(),
        id: 'frontTwoUploadImage',
    });
    stage.add(frontTwoUploadLayer);

    frontTwoUploadLayer.add(frontTwoUploadImage);

    const frontTwoUploadTransformerLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        visible: false,
        id: 'frontTwoUploadTransformerLayer',
    });
    const frontTwoUploaderTransformer = new Konva.Transformer({
        anchorStroke: '#fff',
        borderStroke: '#1a73e8',
        anchorSize: 9,
        anchorFill: '#1a73e8',
        centeredScaling: true,
    });
    frontTwoUploadTransformerLayer.add(frontTwoUploaderTransformer);
    stage.add(frontTwoUploadTransformerLayer);

    const frontTwoTransformerShape = new Konva.Rect({
        draggable: true,
    });
    frontTwoUploadTransformerLayer.add(frontTwoTransformerShape);
    frontTwoUploaderTransformer.nodes([frontTwoTransformerShape]);

    const $dropContainerFrontTwo = document.querySelector('#drop-container-front-two') as HTMLElement;
    const $stageUploadButtonFrontTwo = document.querySelector('#stage-upload-button-front-two') as HTMLButtonElement;
    $stageUploadButtonFrontTwo.addEventListener('click', () => $canvasUploaderLabelFrontTwo.click());

    const $resetFrontTwo = document.querySelector('#reset-front-two') as HTMLButtonElement;
    const $editFrontTwo = document.querySelector('#edit-front-two') as HTMLButtonElement;
    const $changeImageFrontTwo = document.querySelector('#change-image-front-two') as HTMLButtonElement;
    const $doneFrontTwo = document.querySelector('#done-front-two') as HTMLButtonElement;

    const startTransformModeFrontTwo = () => {
        const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;
        const $editorButtonsFrontOne = document.querySelector('#editor-buttons-front-one') as HTMLDivElement;
        const $editorButtonsFrontTwo = document.querySelector('#editor-buttons-front-two') as HTMLDivElement;

        $editorButtons.classList.remove('d-none');
        $editorButtonsFrontOne.classList.add('d-none');
        $editorButtonsFrontTwo.classList.remove('d-none');
        document.querySelectorAll('.front-two-edit-controls').forEach($el => $el.classList.remove('d-none'));
        $editFrontTwo.classList.add('d-none');

        $dropContainersParent.classList.add('pe-none');

        frontTwoZ = frontTwoUploadTransformerLayer.getZIndex();
        frontTwoUploadTransformerLayer.setZIndex(50);
        frontTwoUploadTransformerLayer.show();
    };

    const stopTransformModeFrontTwo = () => {
        const $editorButtonsFrontOne = document.querySelector('#editor-buttons-front-one') as HTMLDivElement;

        $editorButtonsFrontOne.classList.remove('d-none');
        document.querySelectorAll('.front-two-edit-controls').forEach($el => $el.classList.add('d-none'));

        $dropContainersParent.classList.remove('pe-none');

        if (!backFace && frontTwoUploaded) {
            $editFrontTwo.classList.remove('d-none');
        }

        frontTwoUploadTransformerLayer.setZIndex(frontTwoZ);
        frontTwoUploadTransformerLayer.hide();
    };

    let setFrontTwoImageSizeAndPosition: () => void;

    $resetFrontTwo.addEventListener('click', e => {
        e.preventDefault();
        setFrontTwoImageSizeAndPosition?.();
    });

    $editFrontTwo.addEventListener('click', startTransformModeFrontTwo);
    $changeImageFrontTwo.addEventListener('click', () => $canvasUploaderLabelFrontTwo.click());
    $doneFrontTwo.addEventListener('click', stopTransformModeFrontTwo);

    let frontTwoImg = new Image();
    let frontTwoShape: Konva.Shape;

    const addImageFrontTwo = (blobURL: string) => {
        const maskActualWidth = 390;
        const maskActualHeight = 370;
        const maskOffsetX = 1030;
        const maskOffsetY = 715;
        frontTwoImg = new Image();

        const mask = new Image();
        const promise = new Promise<void>(resolve => {
            if (blobURL === '') {
                if (frontTwoShape) {
                    frontTwoShape.destroy();
                }
                $dropContainerFrontTwo.classList.remove('d-none');
                $stageUploadButtonFrontTwo.classList.remove('d-none');
                resolve();
                return;
            }
            mask.onload = () => {
                frontTwoImg.src = blobURL;
                frontTwoImg.setAttribute('style', 'image-orientation:none');
                frontTwoImg.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / frontTwoImg.naturalWidth,
                        height: maskActualHeight / frontTwoImg.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = frontTwoImg.naturalWidth * coverRatio;
                    const newImageHeight = frontTwoImg.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    frontTwoTransformerShape.setAttrs({
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                        scaleX: 1,
                        scaleY: 1,
                    });
                    frontTwoTransformerShape.draw();

                    if (frontTwoShape) {
                        frontTwoShape.destroy();
                    }

                    frontTwoShape = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -frontTwoShape.x(), -frontTwoShape.y(), mask.naturalWidth, mask.naturalHeight);
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = frontTwoUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(frontTwoImg, 0, 0, frontTwoUploaderTransformer.width() / stage.scaleX(), frontTwoUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, frontTwoUploaderTransformer.width() / stage.scaleX(), frontTwoUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(frontTwoShape);
                        },
                    });
                    setFrontTwoImageSizeAndPosition = () => {
                        frontTwoTransformerShape.rotation(0);
                        frontTwoShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        frontTwoTransformerShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        frontTwoTransformerShape.draw();
                    };
                    setFrontTwoImageSizeAndPosition();
                    frontTwoUploadLayer.add(frontTwoShape);

                    frontTwoTransformerShape.off('dragmove');
                    frontTwoTransformerShape.on('dragmove', () => frontTwoShape.position(frontTwoTransformerShape.position()));

                    frontTwoTransformerShape.off('transform');
                    frontTwoTransformerShape.on('transform', () => frontTwoShape.position(frontTwoTransformerShape.position()));

                    frontTwoShape.on('click', () => startTransformModeFrontTwo);

                    hideLoading();
                    resolve();
                };

                $dropContainerFrontTwo.classList.add('d-none');
                $stageUploadButtonFrontTwo.classList.add('d-none');
                startTransformModeFrontTwo();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
        });
        mask.src = `${Relref('/')}img/custom-hc-bottle-openers/hc-mask-left-wrist.png`;
        $canvasContainer.classList.remove('no-edit-btn');
        return promise;
    };

    new uploads.Uploader($canvasUploaderLabelFrontTwo, {
        dropZones: [$dropContainerFrontTwo],
        start: showLoading,
        stop: hideLoading,
        success: async (thumb, uploadID, blobURL) => {
            $navAlert.classList.add('d-none');
            frontTwoUploadID = uploadID;
            frontTwoUploaded = true;
            await addImageFrontTwo(blobURL);
        },
    });

    // stop front two uploader

    // start back one uploader

    let backOneUploadID = 0;
    const backOneUploadLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        width: bgImage.width(),
        height: bgImage.height(),
        id: 'backOneUploadLayer',
    });
    const backOneUploadImage = new Konva.Image({
        image: new Image(),
        id: 'backOneUploadImage',
    });
    stage.add(backOneUploadLayer);

    backOneUploadLayer.add(backOneUploadImage);

    const backOneUploadTransformerLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        visible: false,
        id: 'backOneUploadTransformerLayer',
    });
    const backOneUploaderTransformer = new Konva.Transformer({
        anchorStroke: '#fff',
        borderStroke: '#1a73e8',
        anchorSize: 9,
        anchorFill: '#1a73e8',
        centeredScaling: true,
    });
    backOneUploadTransformerLayer.add(backOneUploaderTransformer);
    stage.add(backOneUploadTransformerLayer);

    const backOneTransformerShape = new Konva.Rect({
        draggable: true,
    });
    backOneUploadTransformerLayer.add(backOneTransformerShape);
    backOneUploaderTransformer.nodes([backOneTransformerShape]);

    const $dropContainerBackOne = document.querySelector('#drop-container-back-one') as HTMLElement;
    const $stageUploadButtonBackOne = document.querySelector('#stage-upload-button-back-one') as HTMLButtonElement;
    $stageUploadButtonBackOne.addEventListener('click', () => $canvasUploaderLabelBackOne.click());

    const $resetBackOne = document.querySelector('#reset-back-one') as HTMLButtonElement;
    const $editBackOne = document.querySelector('#edit-back-one') as HTMLButtonElement;
    const $changeImageBackOne = document.querySelector('#change-image-back-one') as HTMLButtonElement;
    const $doneBackOne = document.querySelector('#done-back-one') as HTMLButtonElement;

    const startTransformModeBackOne = () => {
        const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;
        const $editorButtonsBackOne = document.querySelector('#editor-buttons-back-one') as HTMLDivElement;
        const $editorButtonsBackTwo = document.querySelector('#editor-buttons-back-two') as HTMLDivElement;

        $editorButtons.classList.remove('d-none');
        $editorButtonsBackOne.classList.remove('d-none');
        $editorButtonsBackTwo.classList.add('d-none');
        document.querySelectorAll('.back-one-edit-controls').forEach($el => $el.classList.remove('d-none'));
        $editBackOne.classList.add('d-none');

        $dropContainersParent.classList.add('pe-none');

        backOneZ = backOneUploadTransformerLayer.getZIndex();
        backOneUploadTransformerLayer.setZIndex(50);
        backOneUploadTransformerLayer.show();
    };

    const stopTransformModeBackOne = () => {
        const $editorButtonsBackTwo = document.querySelector('#editor-buttons-back-two') as HTMLDivElement;

        $editorButtonsBackTwo.classList.remove('d-none');
        document.querySelectorAll('.back-one-edit-controls').forEach($el => $el.classList.add('d-none'));

        $dropContainersParent.classList.remove('pe-none');

        if (backFace && backOneUploaded) {
            $editBackOne.classList.remove('d-none');
        }

        backOneUploadTransformerLayer.setZIndex(backOneZ);
        backOneUploadTransformerLayer.hide();
    };

    let setBackOneImageSizeAndPosition: () => void;

    $resetBackOne.addEventListener('click', e => {
        e.preventDefault();
        setBackOneImageSizeAndPosition?.();
    });

    $editBackOne.addEventListener('click', startTransformModeBackOne);
    $changeImageBackOne.addEventListener('click', () => $canvasUploaderLabelBackOne.click());
    $doneBackOne.addEventListener('click', stopTransformModeBackOne);

    let backOneImg = new Image();
    let backOneShape: Konva.Shape;

    const addImageBackOne = (blobURL: string) => {
        const maskActualWidth = 660;
        const maskActualHeight = 715;
        const maskOffsetX = 1910;
        const maskOffsetY = 340;
        backOneImg = new Image();

        const mask = new Image();
        const promise = new Promise<void>(resolve => {
            if (blobURL === '') {
                if (backOneShape) {
                    backOneShape.destroy();
                }
                $dropContainerBackOne.classList.remove('d-none');
                resolve();
                return;
            }
            mask.onload = () => {
                backOneImg.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / backOneImg.naturalWidth,
                        height: maskActualHeight / backOneImg.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = backOneImg.naturalWidth * coverRatio;
                    const newImageHeight = backOneImg.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    backOneTransformerShape.setAttrs({
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                        scaleX: 1,
                        scaleY: 1,
                    });
                    backOneTransformerShape.draw();

                    if (backOneShape) {
                        backOneShape.destroy();
                    }
                    backOneShape = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -backOneShape.x(), -backOneShape.y(), mask.naturalWidth, mask.naturalHeight);
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = backOneUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(backOneImg, 0, 0, backOneUploaderTransformer.width() / stage.scaleX(), backOneUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, backOneUploaderTransformer.width() / stage.scaleX(), backOneUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(backOneShape);
                        },
                    });
                    setBackOneImageSizeAndPosition = () => {
                        backOneTransformerShape.rotation(0);
                        backOneShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        backOneTransformerShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        backOneTransformerShape.draw();
                    };
                    setBackOneImageSizeAndPosition();
                    backOneUploadLayer.add(backOneShape);

                    backOneTransformerShape.off('dragmove');
                    backOneTransformerShape.on('dragmove', () => backOneShape.position(backOneTransformerShape.position()));

                    backOneTransformerShape.off('transform');
                    backOneTransformerShape.on('transform', () => backOneShape.position(backOneTransformerShape.position()));

                    backOneShape.on('click', () => startTransformModeBackOne);

                    hideLoading();
                    resolve();
                };
                backOneImg.src = blobURL;

                $dropContainerBackOne.classList.add('d-none');
                $stageUploadButtonBackOne.classList.add('d-none');
                startTransformModeBackOne();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
        });
        mask.src = `${Relref('/')}img/custom-hc-bottle-openers/hc-mask-right-main.png`;
        $canvasContainer.classList.remove('no-edit-btn');
        return promise;
    };

    new uploads.Uploader($canvasUploaderLabelBackOne, {
        dropZones: [$dropContainerBackOne],
        start: showLoading,
        stop: hideLoading,
        success: async (thumb, uploadID, blobURL) => {
            $navAlert.classList.add('d-none');
            backOneUploadID = uploadID;
            backOneUploaded = true;
            await addImageBackOne(blobURL);
        },
    });

    // stop back one uploader

    // start back two uploader

    let backTwoUploadID = 0;
    const backTwoUploadLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        width: bgImage.width(),
        height: bgImage.height(),
        id: 'backTwoUploadLayer',
    });
    const backTwoUploadImage = new Konva.Image({
        image: new Image(),
        id: 'backTwoUploadImage',
    });
    stage.add(backTwoUploadLayer);

    backTwoUploadLayer.add(backTwoUploadImage);

    const backTwoUploadTransformerLayer = new Konva.Layer({
        x: bgImage.x(),
        y: bgImage.y(),
        visible: false,
        id: 'backTwoUploadTransformerLayer',
    });
    const backTwoUploaderTransformer = new Konva.Transformer({
        anchorStroke: '#fff',
        borderStroke: '#1a73e8',
        anchorSize: 9,
        anchorFill: '#1a73e8',
        centeredScaling: true,
    });
    backTwoUploadTransformerLayer.add(backTwoUploaderTransformer);
    stage.add(backTwoUploadTransformerLayer);

    const backTwoTransformerShape = new Konva.Rect({
        draggable: true,
    });
    backTwoUploadTransformerLayer.add(backTwoTransformerShape);
    backTwoUploaderTransformer.nodes([backTwoTransformerShape]);

    const $dropContainerBackTwo = document.querySelector('#drop-container-back-two') as HTMLElement;
    const $stageUploadButtonBackTwo = document.querySelector('#stage-upload-button-back-two') as HTMLButtonElement;
    $stageUploadButtonBackTwo.addEventListener('click', () => $canvasUploaderLabelBackTwo.click());

    const $resetbackTwo = document.querySelector('#reset-back-two') as HTMLButtonElement;
    const $editBackTwo = document.querySelector('#edit-back-two') as HTMLButtonElement;
    const $changeImagebackTwo = document.querySelector('#change-image-back-two') as HTMLButtonElement;
    const $donebackTwo = document.querySelector('#done-back-two') as HTMLButtonElement;

    const startTransformModeBackTwo = () => {
        const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;
        const $editorButtonsBackOne = document.querySelector('#editor-buttons-back-one') as HTMLDivElement;
        const $editorButtonsBackTwo = document.querySelector('#editor-buttons-back-two') as HTMLDivElement;

        $editorButtons.classList.remove('d-none');
        $editorButtonsBackOne.classList.add('d-none');
        $editorButtonsBackTwo.classList.remove('d-none');
        document.querySelectorAll('.back-two-edit-controls').forEach($el => $el.classList.remove('d-none'));
        $editBackTwo.classList.add('d-none');

        $dropContainersParent.classList.add('pe-none');

        backTwoZ = backTwoUploadTransformerLayer.getZIndex();
        backTwoUploadTransformerLayer.setZIndex(50);
        backTwoUploadTransformerLayer.show();
    };

    const stopTransformModeBackTwo = () => {
        const $editorButtonsBackOne = document.querySelector('#editor-buttons-back-one') as HTMLDivElement;

        $editorButtonsBackOne.classList.remove('d-none');
        document.querySelectorAll('.back-two-edit-controls').forEach($el => $el.classList.add('d-none'));

        $dropContainersParent.classList.remove('pe-none');

        if (backFace && backTwoUploaded) {
            $editBackTwo.classList.remove('d-none');
        }

        backTwoUploadTransformerLayer.setZIndex(backTwoZ);
        backTwoUploadTransformerLayer.hide();
    };

    let setBackTwoImageSizeAndPosition: () => void;

    $resetbackTwo.addEventListener('click', e => {
        e.preventDefault();
        setBackTwoImageSizeAndPosition?.();
    });

    $editBackTwo.addEventListener('click', startTransformModeBackTwo);
    $changeImagebackTwo.addEventListener('click', () => $canvasUploaderLabelBackTwo.click());
    $donebackTwo.addEventListener('click', stopTransformModeBackTwo);

    let backTwoImg = new Image();
    let backTwoShape: Konva.Shape;

    const addImageBackTwo = (blobURL: string) => {
        const maskActualWidth = 390;
        const maskActualHeight = 370;
        const maskOffsetX = 1580;
        const maskOffsetY = 715;
        backTwoImg = new Image();

        const mask = new Image();
        const promise = new Promise<void>(resolve => {
            if (blobURL === '') {
                if (backTwoShape) {
                    backTwoShape.destroy();
                }
                $dropContainerBackTwo.classList.remove('d-none');
                resolve();
                return;
            }
            mask.onload = () => {
                backTwoImg.onload = () => {
                    const originalRatios = {
                        width: maskActualWidth / backTwoImg.naturalWidth,
                        height: maskActualHeight / backTwoImg.naturalHeight,
                    };

                    // formula for cover:
                    const coverRatio = Math.max(originalRatios.width, originalRatios.height);

                    // result:
                    const newImageWidth = backTwoImg.naturalWidth * coverRatio;
                    const newImageHeight = backTwoImg.naturalHeight * coverRatio;

                    const newImageX = maskOffsetX - (newImageWidth - maskActualWidth) / 2;
                    const newImageY = maskOffsetY - (newImageHeight - maskActualHeight) / 2;

                    backTwoTransformerShape.setAttrs({
                        x: newImageX,
                        y: newImageY,
                        width: newImageWidth,
                        height: newImageHeight,
                        scaleX: 1,
                        scaleY: 1,
                    });
                    backTwoTransformerShape.draw();

                    if (backTwoShape) {
                        backTwoShape.destroy();
                    }
                    backTwoShape = new Konva.Shape({
                        sceneFunc: ctx => {
                            ctx.save();
                            ctx.drawImage(mask, -backTwoShape.x(), -backTwoShape.y(), mask.naturalWidth, mask.naturalHeight);
                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-in';

                            const toRadians = Math.PI / 180;
                            const angleInDeg = backTwoUploaderTransformer.rotation();
                            ctx.rotate(angleInDeg * toRadians);
                            ctx.drawImage(backTwoImg, 0, 0, backTwoUploaderTransformer.width() / stage.scaleX(), backTwoUploaderTransformer.height() / stage.scaleX());
                            ctx.rotate(-angleInDeg * toRadians);

                            (ctx as unknown as Record<string, string>)['globalCompositeOperation'] = 'source-over';
                            ctx.restore();
                        },
                        hitFunc: ctx => {
                            ctx.rect(0, 0, backTwoUploaderTransformer.width() / stage.scaleX(), backTwoUploaderTransformer.height() / stage.scaleX());
                            ctx.fillStrokeShape(backTwoShape);
                        },
                    });
                    setBackTwoImageSizeAndPosition = () => {
                        backTwoTransformerShape.rotation(0);
                        backTwoShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        backTwoTransformerShape.setAttrs({
                            x: newImageX,
                            y: newImageY,
                            width: newImageWidth,
                            height: newImageHeight,
                            scaleX: 1,
                            scaleY: 1,
                        });

                        backTwoTransformerShape.draw();
                    };
                    setBackTwoImageSizeAndPosition();
                    backTwoUploadLayer.add(backTwoShape);

                    backTwoTransformerShape.off('dragmove');
                    backTwoTransformerShape.on('dragmove', () => backTwoShape.position(backTwoTransformerShape.position()));

                    backTwoTransformerShape.off('transform');
                    backTwoTransformerShape.on('transform', () => backTwoShape.position(backTwoTransformerShape.position()));

                    backTwoShape.on('click', () => startTransformModeBackTwo);

                    hideLoading();
                    resolve();
                };
                backTwoImg.src = blobURL;

                $dropContainerBackTwo.classList.add('d-none');
                $stageUploadButtonBackTwo.classList.add('d-none');
                startTransformModeBackTwo();

                $uploadRequired.forEach($el => $el.classList.add('d-none'));
            };
        });
        mask.src = `${Relref('/')}img/custom-hc-bottle-openers/hc-mask-right-wrist.png`;
        $canvasContainer.classList.remove('no-edit-btn');
        return promise;
    };

    new uploads.Uploader($canvasUploaderLabelBackTwo, {
        dropZones: [$dropContainerBackTwo],
        start: showLoading,
        stop: hideLoading,
        success: async (thumb, uploadID, blobURL) => {
            $navAlert.classList.add('d-none');
            backTwoUploadID = uploadID;
            backTwoUploaded = true;
            await addImageBackTwo(blobURL);
        },
    });

    // stop back two uploader

    // Disable hit graph for most Konva layers, should improve performance by disabling mouse event detection.
    bgLayer.hitGraphEnabled(false);
    textFrontTopLayer.hitGraphEnabled(false);
    textFrontBottomLayer.hitGraphEnabled(false);
    textBackTopLayer.hitGraphEnabled(false);
    textBackBottomLayer.hitGraphEnabled(false);

    let frontPreviewImgBlob: string;
    let backPreviewImgBlob: string;

    function createCoinPreview() {
        $preview.innerHTML = '';
        $preview.append(template.Clone('#loading'));

        // crop and generate preview images
        scale = 1;
        const $frontPreviewImg = new Image();
        frontPreviewImgBlob = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: offsetX * scale,
            y: offsetY * scale,
            width: 1500 * scale,
            height: 1500 * scale,
        });
        $frontPreviewImg.src = frontPreviewImgBlob;

        const $backPreviewImg = new Image();
        backPreviewImgBlob = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: (offsetX + 1500 + 64) * scale,
            y: offsetY * scale,
            width: 1500 * scale,
            height: 1500 * scale,
        });
        $backPreviewImg.src = backPreviewImgBlob;

        $frontPreviewImg.setAttribute('id', 'front-preview-image');
        $backPreviewImg.setAttribute('id', 'back-preview-image');

        $preview.append($frontPreviewImg);
        $preview.append($backPreviewImg);

        $preview.querySelector('#preview-loading-icon')?.remove();
    }

    $canvasParent.firstElementChild?.setAttribute('id', 'editor');

    const $uploadRequired = document.querySelectorAll('.upload-required');

    document.addEventListener('click', e => {
        if (!frontOneUploadID && !frontTwoUploadID && !backOneUploadID && !backTwoUploadID) {
            return;
        }

        if (e.target !== $canvasContainer &&
            e.target !== $editFrontOne &&
            e.target !== $editFrontTwo &&
            e.target !== $editBackOne &&
            e.target !== $editBackTwo &&
            e.target !== $dropContainersParent &&
            !(e.target instanceof HTMLElement && e.target?.closest('#canvas-container'))) {
            stopTransformModeFrontOne();
            stopTransformModeFrontTwo();
            stopTransformModeBackOne();
            stopTransformModeBackTwo();
        }
    });

    let prev: editorState = {
        textFT: $frontTopText.value ?? '',
        textFB: $frontBottomText.value ?? '',
        textBT: $backTopText.value ?? '',
        textBB: $backBottomText.value ?? '',
        editedTextFT: editedTextFT,
        editedTextFB: editedTextFB,
        editedTextBT: editedTextBT,
        editedTextBB: editedTextBB,
        frontOneUploaded,
        frontTwoUploaded,
        backOneUploaded,
        backTwoUploaded,
        imageFrontOne: {
            imageSrc: frontOnePlaceholderImg,
            posX: frontOneTransformerShape.x(),
            posY: frontOneTransformerShape.y(),
            width: frontOneTransformerShape.width(),
            height: frontOneTransformerShape.height(),
            scaleX: frontOneTransformerShape.scaleX(),
            scaleY: frontOneTransformerShape.scaleY(),
            uploadID: frontOneUploadID ?? 0,
        },
        imageFrontTwo: {
            imageSrc: defaultPlaceholderImg,
            posX: frontTwoTransformerShape.x(),
            posY: frontTwoTransformerShape.y(),
            width: frontTwoTransformerShape.width(),
            height: frontTwoTransformerShape.height(),
            scaleX: frontTwoTransformerShape.scaleX(),
            scaleY: frontTwoTransformerShape.scaleY(),
            uploadID: frontTwoUploadID ?? 0,
        },
        imageBackOne: {
            imageSrc: backOnePlaceholderImg,
            posX: backOneTransformerShape.x(),
            posY: backOneTransformerShape.y(),
            width: backOneTransformerShape.width(),
            height: backOneTransformerShape.height(),
            scaleX: backOneTransformerShape.scaleX(),
            scaleY: backOneTransformerShape.scaleY(),
            uploadID: backOneUploadID ?? 0,
        },
        imageBackTwo: {
            imageSrc: defaultPlaceholderImg,
            posX: backTwoTransformerShape.x(),
            posY: backTwoTransformerShape.y(),
            width: backTwoTransformerShape.width(),
            height: backTwoTransformerShape.height(),
            scaleX: backTwoTransformerShape.scaleX(),
            scaleY: backTwoTransformerShape.scaleY(),
            uploadID: backTwoUploadID ?? 0,
        },
    };

    function modalEditor() {
        const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;

        $fields?.classList.remove('d-none');
        $editorButtons?.classList.remove('d-none');
        $modalDivider?.classList.add('d-lg-flex');
        $reopenEditor.classList.add('d-none');

        modalActive = true;
        const prevFirstOpen = firstOpen;

        prev = {
            textFT: $frontTopText.value ?? '',
            textFB: $frontBottomText.value ?? '',
            textBT: $backTopText.value ?? '',
            textBB: $backBottomText.value ?? '',
            editedTextFT: editedTextFT,
            editedTextFB: editedTextFB,
            editedTextBT: editedTextBT,
            editedTextBB: editedTextBB,
            frontOneUploaded,
            frontTwoUploaded,
            backOneUploaded,
            backTwoUploaded,
            imageFrontOne: {
                imageSrc: '',
                posX: frontOneTransformerShape.x(),
                posY: frontOneTransformerShape.y(),
                width: frontOneTransformerShape.width(),
                height: frontOneTransformerShape.height(),
                scaleX: frontOneTransformerShape.scaleX(),
                scaleY: frontOneTransformerShape.scaleY(),
                uploadID: frontOneUploadID ?? 0,
            },
            imageFrontTwo: {
                imageSrc: '',
                posX: frontTwoTransformerShape.x(),
                posY: frontTwoTransformerShape.y(),
                width: frontTwoTransformerShape.width(),
                height: frontTwoTransformerShape.height(),
                scaleX: frontTwoTransformerShape.scaleX(),
                scaleY: frontTwoTransformerShape.scaleY(),
                uploadID: frontTwoUploadID ?? 0,
            },
            imageBackOne: {
                imageSrc: '',
                posX: backOneTransformerShape.x(),
                posY: backOneTransformerShape.y(),
                width: backOneTransformerShape.width(),
                height: backOneTransformerShape.height(),
                scaleX: backOneTransformerShape.scaleX(),
                scaleY: backOneTransformerShape.scaleY(),
                uploadID: backOneUploadID ?? 0,
            },
            imageBackTwo: {
                imageSrc: '',
                posX: backTwoTransformerShape.x(),
                posY: backTwoTransformerShape.y(),
                width: backTwoTransformerShape.width(),
                height: backTwoTransformerShape.height(),
                scaleX: backTwoTransformerShape.scaleX(),
                scaleY: backTwoTransformerShape.scaleY(),
                uploadID: backTwoUploadID ?? 0,
            },
        };

        prev.imageFrontOne.imageSrc = frontOneImg.src;
        prev.imageFrontTwo.imageSrc = frontTwoImg.src;
        prev.imageBackOne.imageSrc = backOneImg.src;
        prev.imageBackTwo.imageSrc = backTwoImg.src;

        if (firstOpen) {
            void updateFrontTopText('');
            void updateFrontBottomText('');
            void updateBackTopText('');
            void updateBackBottomText('');

            void addImageFrontOne('').then(stopTransformModeFrontOne);
            void addImageFrontTwo('').then(stopTransformModeFrontTwo);
            void addImageBackOne('').then(stopTransformModeBackOne);
            void addImageBackTwo('').then(stopTransformModeBackTwo);
        }

        firstOpen = false;

        function modalToFront() {
            const $modal = document.querySelector('.modal.show') as HTMLDivElement;
            const $editorButtonsFrontOne = $modal.querySelector('#editor-buttons-front-one') as HTMLDivElement;
            const $editorButtonsFrontTwo = $modal.querySelector('#editor-buttons-front-two') as HTMLDivElement;
            const $editorButtonsBackOne = $modal.querySelector('#editor-buttons-back-one') as HTMLDivElement;
            const $editorButtonsBackTwo = $modal.querySelector('#editor-buttons-back-two') as HTMLDivElement;

            $modalToFrontSM.setAttribute('style', 'opacity:0');
            $modalToFrontSM.setAttribute('disabled', '');

            $navAlert.classList.add('d-none');
            backFace = false;

            stopTransformModeBackOne();
            stopTransformModeBackTwo();

            modalTitle.textContent = 'Front of Coin';

            $frontInputs?.classList.remove('d-none');
            $backInputs?.classList.add('d-none');

            $editBackOne?.classList.add('d-none');
            $editBackTwo?.classList.add('d-none');
            $editFrontOne?.classList.add('d-none');
            $editFrontTwo?.classList.add('d-none');

            $editorButtonsFrontOne.classList.remove('d-none');
            $editorButtonsFrontTwo.classList.remove('d-none');
            $editorButtonsBackOne.classList.add('d-none');
            $editorButtonsBackTwo.classList.add('d-none');

            $stageUploadButtonBackOne.classList.add('d-none');
            $stageUploadButtonBackTwo.classList.add('d-none');

            fitStageIntoParentContainer(false);

            $dropContainerBackOne?.classList.add('d-none');
            $dropContainerBackTwo?.classList.add('d-none');
            if (!frontOneUploaded) {
                $dropContainerFrontOne?.classList.remove('d-none');
                $stageUploadButtonFrontOne.classList.remove('d-none');
                $canvasContainer.classList.add('no-edit-btn');
                $editorButtons.classList.add('d-none');
            } else {
                $editorButtons.classList.remove('d-none');
                $editFrontOne?.classList.remove('d-none');
                $canvasContainer.classList.remove('no-edit-btn');
            }
            if (!frontTwoUploaded) {
                $dropContainerFrontTwo?.classList.remove('d-none');
                $stageUploadButtonFrontTwo.classList.remove('d-none');
                $canvasContainer.classList.add('no-edit-btn');
                $editorButtons.classList.add('d-none');
            } else {
                $editorButtons.classList.remove('d-none');
                $editFrontTwo?.classList.remove('d-none');
                $canvasContainer.classList.remove('no-edit-btn');
            }
        }
        function modalToBack() {
            const $modal = document.querySelector('.modal.show') as HTMLDivElement;
            const $editorButtonsFrontOne = $modal.querySelector('#editor-buttons-front-one') as HTMLDivElement;
            const $editorButtonsFrontTwo = $modal.querySelector('#editor-buttons-front-two') as HTMLDivElement;
            const $editorButtonsBackOne = $modal.querySelector('#editor-buttons-back-one') as HTMLDivElement;
            const $editorButtonsBackTwo = $modal.querySelector('#editor-buttons-back-two') as HTMLDivElement;

            $modalToFrontSM.removeAttribute('style');
            $modalToFrontSM.removeAttribute('disabled');

            $navAlert.classList.add('d-none');
            backFace = true;

            stopTransformModeFrontOne();
            stopTransformModeFrontTwo();

            modalTitle.textContent = 'Back of Coin';

            $frontInputs?.classList.add('d-none');
            $backInputs?.classList.remove('d-none');

            $editFrontOne?.classList.add('d-none');
            $editFrontTwo?.classList.add('d-none');
            $editBackOne?.classList.add('d-none');
            $editBackTwo?.classList.add('d-none');

            $editorButtonsFrontOne.classList.add('d-none');
            $editorButtonsFrontTwo.classList.add('d-none');
            $editorButtonsBackOne.classList.remove('d-none');
            $editorButtonsBackTwo.classList.remove('d-none');

            $stageUploadButtonFrontOne.classList.add('d-none');
            $stageUploadButtonFrontTwo.classList.add('d-none');

            fitStageIntoParentContainer(false);

            $dropContainerFrontOne?.classList.add('d-none');
            $dropContainerFrontTwo?.classList.add('d-none');
            if (!backOneUploaded) {
                $dropContainerBackOne?.classList.remove('d-none');
                $stageUploadButtonBackOne.classList.remove('d-none');
                $canvasContainer.classList.add('no-edit-btn');
                $editorButtons.classList.add('d-none');
            } else {
                $editorButtons.classList.remove('d-none');
                $editBackOne?.classList.remove('d-none');
                $canvasContainer.classList.remove('no-edit-btn');
            }
            if (!backTwoUploaded) {
                $dropContainerBackTwo?.classList.remove('d-none');
                $stageUploadButtonBackTwo.classList.remove('d-none');
                $canvasContainer.classList.add('no-edit-btn');
                $editorButtons.classList.add('d-none');
            } else {
                $editorButtons.classList.remove('d-none');
                $editBackTwo?.classList.remove('d-none');
                $canvasContainer.classList.remove('no-edit-btn');
            }
        }

        const modalBtnToFront = () => {
            activeModal.$element.querySelector('.btn-modal-to-back')?.classList.remove('d-none');
            activeModal.$element.querySelector('.btn-modal-to-front')?.classList.add('d-none');
            activeModal.$element.querySelector('.btn-modal-complete')?.classList.add('d-none');
            modalToFront();
        };

        const modalBtnToBack = () => {
            if (!frontOneUploadID || !frontTwoUploadID) {
                $navAlert.classList.remove('d-none');
                return;
            }
            activeModal.$element.querySelector('.btn-modal-to-back')?.classList.add('d-none');
            activeModal.$element.querySelector('.btn-modal-to-front')?.classList.remove('d-none');
            activeModal.$element.querySelector('.btn-modal-complete')?.classList.remove('d-none');
            modalToBack();
        };

        if (!frontOneUploaded) {
            $dropContainerFrontOne?.classList.remove('d-none');
            $stageUploadButtonFrontOne.classList.remove('d-none');
        }

        if (!frontTwoUploaded) {
            $dropContainerFrontTwo?.classList.remove('d-none');
            $stageUploadButtonFrontTwo.classList.remove('d-none');
        }

        $dropContainerBackOne?.classList.remove('d-none');
        $dropContainerBackTwo?.classList.remove('d-none');

        for (const $el of Array.from($uploadRequired)) {
            $el.classList.add('d-none');
        }

        $modalMainRow.classList.remove('d-none');
        $preview?.classList.add('d-none');

        $modalCanvasParent.removeAttribute('style');

        const exitModal = async (cancel?: boolean) => {
            stopTransformModeFrontOne();
            stopTransformModeFrontTwo();
            stopTransformModeBackOne();
            stopTransformModeBackTwo();

            const $editorButtons = document.querySelector('#editor-buttons') as HTMLDivElement;

            $metaThemeColor.content = initialThemeColor;

            $editFrontOne?.classList.add('d-none');
            $editFrontTwo?.classList.add('d-none');
            $editBackOne?.classList.add('d-none');
            $editBackTwo?.classList.add('d-none');

            $fields?.classList.add('d-none');
            $editorButtons?.classList.add('d-none');
            $dropContainerFrontOne?.classList.add('d-none');
            $dropContainerFrontTwo?.classList.add('d-none');
            $dropContainerBackOne?.classList.add('d-none');
            $dropContainerBackTwo?.classList.add('d-none');
            $modalDivider?.classList.remove('d-lg-flex');

            modalActive = false;

            $modalCanvasParent.style.position = 'absolute';
            $modalCanvasParent.style.top = '-10000px';
            $modalCanvasParent.style.left = '-10000px';

            fitStageIntoParentContainer(false);

            if (!editedTextFT) {
                await updateFrontTopText('');
            }
            if (!editedTextFB) {
                await updateFrontBottomText('');
            }
            if (!editedTextBT) {
                await updateBackTopText('');
            }
            if (!editedTextBB) {
                await updateBackBottomText('');
            }

            $preview?.classList.remove('d-none');

            if (cancel) {
                await resetToPrev().then(() => {
                    createCoinPreview();
                    firstOpen = prevFirstOpen;
                });
            } else {
                createCoinPreview();
                firstOpen = false;
            }

            if (!firstOpen) {
                $personalize.classList.add('d-none');
                $addToCart.classList.remove('d-none');
                $quantity.parentElement?.classList.remove('d-none');
                $reopenEditor.classList.remove('d-none');
            }

            $modalMainRow.classList.add('d-none');
            activeModal.close();
        };

        async function resetToPrev() {
            if (prevFirstOpen) {
                await addImageFrontOne(frontOnePlaceholderImg).then(stopTransformModeFrontOne);
                await addImageFrontTwo(defaultPlaceholderImg).then(stopTransformModeFrontTwo);
                await addImageBackOne(backOnePlaceholderImg).then(stopTransformModeBackOne);
                await addImageBackTwo(defaultPlaceholderImg).then(stopTransformModeBackTwo);
            } else {
                // Reset front one image
                await addImageFrontOne(prev.imageFrontOne.imageSrc).then(() => {
                    stopTransformModeFrontOne();
                    if (frontOneShape) {
                        frontOneShape.setAttrs({
                            x: prev.imageFrontOne.posX,
                            y: prev.imageFrontOne.posY,
                        });
                        frontOneTransformerShape.setAttrs({
                            x: prev.imageFrontOne.posX,
                            y: prev.imageFrontOne.posY,
                            width: prev.imageFrontOne.width,
                            height: prev.imageFrontOne.height,
                            scaleX: prev.imageFrontOne.scaleX,
                            scaleY: prev.imageFrontOne.scaleY,
                        });
                    }
                }).catch();
                frontOneUploaded = prev.frontOneUploaded;

                // Reset front two image
                await addImageFrontTwo(prev.imageFrontTwo.imageSrc).then(() => {
                    stopTransformModeFrontTwo();
                    if (frontTwoShape) {
                        frontTwoShape.setAttrs({
                            x: prev.imageFrontTwo.posX,
                            y: prev.imageFrontTwo.posY,
                        });
                        frontTwoTransformerShape.setAttrs({
                            x: prev.imageFrontTwo.posX,
                            y: prev.imageFrontTwo.posY,
                            width: prev.imageFrontTwo.width,
                            height: prev.imageFrontTwo.height,
                            scaleX: prev.imageFrontTwo.scaleX,
                            scaleY: prev.imageFrontTwo.scaleY,
                        });
                    }
                }).catch();
                frontTwoUploaded = prev.frontTwoUploaded;

                // Reset back one image
                await addImageBackOne(prev.imageBackOne.imageSrc).then(() => {
                    stopTransformModeBackOne();
                    if (backOneShape) {
                        backOneShape.setAttrs({
                            x: prev.imageBackOne.posX,
                            y: prev.imageBackOne.posY,
                        });
                        backOneTransformerShape.setAttrs({
                            x: prev.imageBackOne.posX,
                            y: prev.imageBackOne.posY,
                            width: prev.imageBackOne.width,
                            height: prev.imageBackOne.height,
                            scaleX: prev.imageBackOne.scaleX,
                            scaleY: prev.imageBackOne.scaleY,
                        });
                    }
                }).catch();
                backOneUploaded = prev.backOneUploaded;

                // Reset back two image
                await addImageBackTwo(prev.imageBackTwo.imageSrc).then(() => {
                    stopTransformModeBackTwo();
                    if (backTwoShape) {
                        backTwoShape.setAttrs({
                            x: prev.imageBackTwo.posX,
                            y: prev.imageBackTwo.posY,
                        });
                        backTwoTransformerShape.setAttrs({
                            x: prev.imageBackTwo.posX,
                            y: prev.imageBackTwo.posY,
                            width: prev.imageBackTwo.width,
                            height: prev.imageBackTwo.height,
                            scaleX: prev.imageBackTwo.scaleX,
                            scaleY: prev.imageBackTwo.scaleY,
                        });
                    }
                }).catch();
                backTwoUploaded = prev.backTwoUploaded;
            }
            // Reset Text
            let resetTextFT: string;
            let resetTextFB: string;
            let resetTextBT: string;
            let resetTextBB: string;

            if (prevFirstOpen) {
                resetTextFT = 'FRONT TOP TEXT';
                resetTextFB = 'FRONT BOTTOM TEXT';
                resetTextBT = 'BACK TOP TEXT';
                resetTextBB = 'BACK BOTTOM TEXT';
            } else {
                if (prev.editedTextFT) {
                    resetTextFT = prev.textFT;
                } else {
                    resetTextFT = '';
                }
                if (prev.editedTextFB) {
                    resetTextFB = prev.textFB;
                } else {
                    resetTextFB = '';
                }
                if (prev.editedTextBT) {
                    resetTextBT = prev.textBT;
                } else {
                    resetTextBT = '';
                }
                if (prev.editedTextBB) {
                    resetTextBB = prev.textBB;
                } else {
                    resetTextBB = '';
                }
            }
            await updateFrontTopText(resetTextFT);
            await updateFrontBottomText(resetTextFB);
            await updateBackTopText(resetTextBT);
            await updateBackBottomText(resetTextBB);
            $frontTopText.value = prev.textFT;
            $frontBottomText.value = prev.textFB;
            $backTopText.value = prev.textBT;
            $backBottomText.value = prev.textBB;

            editedTextFT = prev.editedTextFT;
            editedTextFB = prev.editedTextFB;
            editedTextBT = prev.editedTextBT;
            editedTextBB = prev.editedTextBB;

            // Reset upload IDs
            frontOneUploadID = prev.imageFrontOne.uploadID;
            frontTwoUploadID = prev.imageFrontTwo.uploadID;
            backOneUploadID = prev.imageBackOne.uploadID;
            backTwoUploadID = prev.imageBackTwo.uploadID;

            // Should now be fully reset
        }

        $metaThemeColor.content = '#ffffff';

        const activeModal = new Modal({
            title: 'Front of Coin',
            size: 'modal-lg',
            body: $modalCanvasParent,
            outsideClosable: false,
            submitAutoFocus: false,
            buttons: [
                {
                    text: 'Complete Coin Design',
                    class: 'btn btn-secondary text-white btn-modal-complete d-none',
                    click: async () => {
                        if (!frontOneUploadID || !frontTwoUploadID || !backOneUploadID || !backTwoUploadID) {
                            $navAlert.classList.remove('d-none');
                            return;
                        } else {
                            await exitModal(false);
                        }
                    },
                },
                {
                    text: 'Edit Back of Coin >',
                    class: 'btn btn-secondary text-white btn-modal-to-back',
                    click: modalBtnToBack,
                },
                {
                    text: '< Edit Front of Coin',
                    class: 'btn btn-outline-secondary btn-modal-to-front d-none',
                    click: modalBtnToFront,
                },
            ],
            onClose: () => exitModal(true),
        });

        // The button constructor in the modal was treating the FontAwesome tags as literal,
        // so this is just resetting it to get it to show correctly.
        // The buttons have plain text carets < and > as placeholders by default, before this runs.

        const buttonToBack = activeModal.$element.querySelector('.btn-modal-to-back') as HTMLButtonElement;
        buttonToBack.innerHTML = 'Edit Back of Coin <i class="fas fa-chevron-right"></i>';

        const buttonToFront = activeModal.$element.querySelector('.btn-modal-to-front') as HTMLButtonElement;
        buttonToFront.innerHTML = '<i class="fas fa-chevron-left"></i> Front of Coin';

        // Remove the modal confirm button so we can use ours that checks for uploads before closing
        activeModal.$element.querySelector('#modal-confirm-btn')?.remove();
        activeModal.$element.querySelector('.btn-modal-complete')?.classList.add('d-none');

        const $modalHeader = activeModal.$element.querySelector('.modal-header') as HTMLDivElement;
        $modalHeader.prepend(template.Clone('#modal-sm-back-button'));
        const $modalToFrontSM = document.querySelector('.btn-back') as HTMLButtonElement;

        $modalToFrontSM.addEventListener('click', modalBtnToFront);

        const modalTitle = activeModal.$element.querySelector('.modal-title') as HTMLHeadingElement;

        modalToFront();
    }

    $personalize.addEventListener('click', e => {
        e.preventDefault();
        modalEditor();
    });

    function initPreview() {
        $modalMainRow.classList.remove('d-none');
        $preview?.classList.add('d-none');
        createCoinPreview();
        $modalMainRow.classList.add('d-none');
        $preview?.classList.remove('d-none');
    }

    $reopenEditor.addEventListener('click', e => {
        e.preventDefault();
        modalEditor();
    });

    interface textField {
        name: string;
        value: string;
    }

    function textFieldCartParams(): textField[] {
        const fields: textField[] = [];
        if ($frontTopText.value !== '') {
            fields.push({
                name: 'Front Top Text',
                value: $frontTopText.value,
            });
        }
        if ($frontBottomText.value !== '') {
            fields.push({
                name: 'Front Bottom Text',
                value: $frontBottomText.value,
            });
        }
        if ($backTopText.value !== '') {
            fields.push({
                name: 'Back Top Text',
                value: $backTopText.value,
            });
        }
        if ($backBottomText.value !== '') {
            fields.push({
                name: 'Back Bottom Text',
                value: $backBottomText.value,
            });
        }
        return fields;
    }

    $form.noValidate = true;
    $form.addEventListener('submit', async e => {
        e.preventDefault();

        if (!frontOneUploadID || !frontTwoUploadID || !backOneUploadID || !backTwoUploadID) {
            for (const $el of Array.from($uploadRequired)) {
                $el.classList.remove('d-none');
            }
            return;
        }

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($addToCart);

        // clean up empty inputs
        if (!$frontTopText.value) {
            $frontTopText.dispatchEvent(new Event('input'));
        }
        if (!$frontBottomText.value) {
            $frontBottomText.dispatchEvent(new Event('input'));
        }

        if (!$backTopText.value) {
            $backTopText.dispatchEvent(new Event('input'));
        }
        if (!$backBottomText.value) {
            $backBottomText.dispatchEvent(new Event('input'));
        }

        bgLayer.hide();

        scale = 1.9755;

        const frontURL = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: 144,
            y: 246,
            width: 1308,
            height: 1029,
            pixelRatio: 1.9755,
        });

        const backURL = stage.toDataURL({
            quality: 1,
            mimeType: 'image/png',
            x: 1596,
            y: 246,
            width: 1308,
            height: 1029,
            pixelRatio: 1.9755,
        });

        bgLayer.show();

        const previewUpload = await uploads.NewFromURL([{
            name: 'preview.png',
            mime: 'image/png',
            url: frontPreviewImgBlob,
        }]);

        const stageUploads = await uploads.NewFromURL([
            {
                name: '.front.jpg',
                mime: 'image/jpeg',
                url: await stockitems.ColorLayer(frontURL),
            },
            {
                name: '.front-white.jpg',
                mime: 'image/jpeg',
                url: await stockitems.WhiteLayer(frontURL),
            },
            {
                name: '.back.jpg',
                mime: 'image/jpeg',
                url: await stockitems.ColorLayer(backURL),
            },
            {
                name: '.back-white.jpg',
                mime: 'image/jpeg',
                url: await stockitems.WhiteLayer(backURL),
            },
        ]);

        const params: AddCartItemParamsUpload = {
            uploadID: previewUpload[0].uploadID,
            quantity: parseInt($quantity.value, 10),
            options: textFieldCartParams(),
            cartItemUploadIDs: [frontOneUploadID, frontTwoUploadID, backOneUploadID, backTwoUploadID, ...stageUploads.map(u => u.uploadID)],
            uploadLineItem: {
                name: 'Custom Handcuff Bottle Openers',
                lineItem: 'challenge coins',
                type: 'Made in USA - Simulated Enamel Coin',
                size: '1.85" × 2.25" Signature: Handcuff Bottle Opener',
                networkSKUID: models.NetworkSKUID.NETWORK_SK_US_CUSTOM_HANDCUFF_BOTTLE_OPENERS,
                childLineItems: [
                    {
                        child: 'plating',
                        option: 'antique silver',
                    },
                    {
                        child: 'edge',
                        option: 'standard',
                    },
                ],
            },
        };

        AddCartItems(params).then(() => {
            window.location.href = Relref('/cart');
        }).catch(err => {
            $fieldset.disabled = false;
            buttons.Stop($addToCart);
            ShowError(err);
        });
    });

    fitStageIntoParentContainer();
    window.addEventListener('resize', () => fitStageIntoParentContainer(false));

    void Promise.all([
        addImageFrontOne(frontOnePlaceholderImg),
        addImageFrontTwo(defaultPlaceholderImg),
        addImageBackOne(backOnePlaceholderImg),
        addImageBackTwo(defaultPlaceholderImg),
        frontTopPromise,
        frontBottomPromise,
        backTopPromise,
        backBottomPromise,
    ]).then(() => {
        stopTransformModeFrontOne();
        stopTransformModeFrontTwo();
        stopTransformModeBackOne();
        stopTransformModeBackTwo();
        initPreview();
        $preview.querySelector('#preview-loading-icon')?.remove();
    });

    initPreview();
    $preview.querySelector('#preview-loading-icon')?.remove();
}
